import React from 'react';
import { Helmet } from 'react-helmet';
import CreateOrUpdateManufacturerForm from 'components/Form/Tenant/CreateOrUpdateManufacturerForm';
import { Container } from 'reactstrap';

const ManufacturerFormPage: React.FC = () => {
  return (
    <div className="page-content">
      <Helmet>
        <title>Manufacturer Form</title>
      </Helmet>
      <Container fluid>
        <CreateOrUpdateManufacturerForm />
      </Container>
    </div>
  );
};

export default ManufacturerFormPage;
